import { PageHeadAddon, PageHeadProps } from '../types';

import { isAddonLeftTuple } from './isAddonLeftTuple';

/**
 * Приводит `addonLeft` к массиву, чтобы один и два компонента можно было отрисовать одним `map`.
 * @kind helper
 * @param addonLeft - `addonLeft` PageHead: `undefined`, одиночная функция-компонент или tuple
 * @returns массив функций аддонов: `[]` для `undefined`, `[fn]` для одиночной функции-компонента, tuple как есть
 */
export const normalizeAddonLeft = (addonLeft: PageHeadProps['addonLeft']): readonly PageHeadAddon[] => {
    if (!addonLeft) {
        return [];
    }

    if (isAddonLeftTuple(addonLeft)) {
        return addonLeft;
    }

    return [addonLeft];
};
